/**
 * Call Status Component
 * Displays the current call status with appropriate styling
 */

import { motion } from 'framer-motion';
import { Phone, PhoneOff, Loader2 } from 'lucide-react';
import type { CallStatusProps } from '@/types';
import { fadeInUp } from '@/utils/constants';

export function CallStatus({ status }: CallStatusProps) {
  const statusConfig = {
    idle: {
      text: 'Prêt à discuter',
      icon: Phone,
      color: 'text-gray-300',
      animate: false,
    },
    connecting: {
      text: 'Connexion...',
      icon: Loader2,
      color: 'text-yellow-400',
      animate: true,
    },
    active: {
      text: 'En conversation',
      icon: Phone,
      color: 'text-green-400',
      animate: false,
    },
    ended: {
      text: 'Conversation terminée',
      icon: PhoneOff,
      color: 'text-gray-400',
      animate: false,
    },
    error: {
      text: 'Erreur de connexion',
      icon: PhoneOff,
      color: 'text-red-400',
      animate: false,
    },
  };

  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <motion.div
      variants={fadeInUp}
      initial="initial"
      animate="animate"
      className="flex items-center space-x-1 md:space-x-2"
    >
      <Icon
        className={`h-3.5 w-3.5 md:h-5 md:w-5 ${config.color} ${config.animate ? 'animate-spin' : ''}`}
      />
      <span className={`text-xs md:text-sm font-medium ${config.color} leading-tight`}>
        {config.text}
      </span>
    </motion.div>
  );
}
